import Udesk from 'Udesk';
import React, { FC, memo } from 'react';
import { Redirect } from 'react-router-dom';
import SubRoutes from 'udesk-react/src/components/sub-routes';

interface TemplateProps {
    sdkOptions?: any;
    route?: any;
    location?: any;
    match?: any;
    routes?: any[];
}

const Template: FC<TemplateProps> = memo((props) => {
    const { sdkOptions, route, location, match, routes = [] } = props;

    console.log(props);

    const isRedirect = (currentPath: string, toPath: string) => {
        if (currentPath === toPath) {
            return true;
        }
        return false;
    };

    if (isRedirect(route.path, location.pathname)) {
        let toPath = Udesk.ui.routing.getRouteFirstBottomedChildRoutePath({
            routeName: route.name,
            pathParams: match.params,
        });
        return <Redirect to={toPath} sdkOptions={sdkOptions} />;
    } else {
        return (
            <div style={{ height: '100%' }}>
                {routes.map((routeItem, i) => (
                    <SubRoutes key={i} route={routeItem} />
                ))}
            </div>
        );
    }
});

export default Template;
